import React from "react";
import Text from "@src/lib/ui/Text";
import { cn } from "@src/lib/utils/cn";

export type InfoTableItem = {
  label: string;
  value: React.ReactNode;
};

type Props = {
  items: InfoTableItem[];
  title?: string;
  className?: string;
};

const InfoTable: React.FC<Props> = ({ items, title, className }) => {
  return (
    <div className={cn("space-y-4 mt-3", className)}>
      {title && (
        <Text variant="body-title" className="mb-4">
          {title}
        </Text>
      )}
      <div className="w-fit">
        <div className="grid grid-cols-[auto_1fr] items-center gap-x-4 gap-y-2">
          {items.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <Text
                  variant="compact-title"
                  className="min-w-[160px] whitespace-nowrap"
                >
                  {item.label}
                </Text>
                {typeof item.value === "string" ? (
                  <Text variant="compact-description">{item.value}</Text>
                ) : (
                  item.value
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default InfoTable;
